function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { fetchFilteredColumns, handleXDDQuery, runColumnQuery, runMapQuery, asyncGetElevation, getPBDBData, base, fetchAllColumns } from "./fetch";
import axios from "axios";
import { runFilter } from "./filters";
import { push } from "@lagunovsky/redux-react-router";
import { routerBasename } from "~/map-interface/settings";
import { isDetailPanelRoute } from "../nav-hooks";
import { MenuPage, setInfoMarkerPosition } from "../reducers";
import { formatCoordForZoomLevel } from "~/map-interface/utils/formatting";
import { currentPageForPathName } from "../nav-hooks";
import { getInitialStateFromHash } from "../reducers/hash-string";
import { findColumnForLocation } from "./columns";
import { MapLayer } from "../reducers/core";

function actionRunner(_x, _x2) {
  return _actionRunner.apply(this, arguments);
}

function _actionRunner() {
  _actionRunner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(state, action) {
    var _state$menu$activePag;

    var dispatch,
        coreState,
        _pathname,
        s1,
        _coreState,
        activePage,
        _getInitialStateFromH,
        _getInitialStateFromH2,
        coreState1,
        filters,
        columns,
        newFilters,
        mapLayers,
        _columns,
        _activePage,
        _pathname2,
        _action$page,
        newPathname,
        pathname,
        term,
        CancelToken,
        source,
        res,
        mapInfo,
        CancelToken1,
        source1,
        gdd_data,
        result,
        _lng,
        _lat,
        _z,
        ln,
        lt,
        lng,
        lat,
        z,
        map_id,
        column,
        CancelTokenMapQuery,
        sourceMapQuery,
        mapData,
        _findColumnForLocatio,
        columnInfo,
        CancelTokenGetColumn,
        sourceGetColumn,
        columnData,
        CancelTokenElevation,
        sourceElevation,
        elevationData,
        collection_nos,
        _args = arguments;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dispatch = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
            coreState = state.core;
            _context.t0 = action.type;
            _context.next = _context.t0 === "get-initial-map-state" ? 5 : _context.t0 === "map-layers-changed" ? 22 : _context.t0 === "toggle-menu" ? 31 : _context.t0 === "go-to-experiments-panel" ? 36 : _context.t0 === "set-menu-page" ? 41 : _context.t0 === "close-infodrawer" ? 47 : _context.t0 === "fetch-search-query" ? 51 : _context.t0 === "fetch-xdd" ? 59 : _context.t0 === "select-search-result" ? 67 : _context.t0 === "async-add-filter" ? 76 : _context.t0 === "get-filtered-columns" ? 80 : _context.t0 === "map-query" ? 84 : _context.t0 === "run-map-query" ? 88 : _context.t0 === "get-column-units" ? 103 : _context.t0 === "get-elevation" ? 110 : _context.t0 === "get-pbdb" ? 117 : 123;
            break;

          case 5:
            _pathname = state.router.location.pathname;
            s1 = setInfoMarkerPosition(state);
            _coreState = s1.core;
            activePage = currentPageForPathName(_pathname); // Harvest as much information as possible from the hash string

            _getInitialStateFromH = getInitialStateFromHash(_coreState, state.router.location.hash), _getInitialStateFromH2 = _slicedToArray(_getInitialStateFromH, 2), coreState1 = _getInitialStateFromH2[0], filters = _getInitialStateFromH2[1]; // Fill out the remainder with defaults
            // We always get all columns on initial load, which might be
            // a bit unnecessary

            columns = null;

            if (!coreState1.mapLayers.has(MapLayer.COLUMNS)) {
              _context.next = 15;
              break;
            }

            _context.next = 14;
            return fetchAllColumns();

          case 14:
            columns = _context.sent;

          case 15:
            dispatch({
              type: "replace-state",
              state: _objectSpread(_objectSpread({}, state), {}, {
                core: _objectSpread(_objectSpread({}, coreState1), {}, {
                  allColumns: columns,
                  initialLoadComplete: true
                }),
                menu: {
                  activePage: activePage
                }
              })
            }); // Apply all filters in parallel

            _context.next = 18;
            return Promise.all(filters.map(function (f) {
              return runFilter(f);
            }));

          case 18:
            newFilters = _context.sent;
            _context.next = 21;
            return dispatch({
              type: "set-filters",
              filters: newFilters
            });

          case 21:
            return _context.abrupt("return", {
              type: "map-layers-changed",
              mapLayers: coreState1.mapLayers
            });

          case 22:
            mapLayers = action.mapLayers;

            if (!(mapLayers.has(MapLayer.COLUMNS) && state.core.allColumns == null)) {
              _context.next = 30;
              break;
            }

            _context.next = 26;
            return fetchAllColumns();

          case 26:
            _columns = _context.sent;
            return _context.abrupt("return", {
              type: "set-all-columns",
              columns: _columns
            });

          case 30:
            return _context.abrupt("return", null);

          case 31:
            // Push the menu onto the history stack
            _activePage = state.menu.activePage; // If input is focused we want to open the menu if clicked, not run the toggle action.

            if (_activePage != null && !state.core.inputFocus) {
              _activePage = null;
            } else {
              _activePage = MenuPage.LAYERS;
            }

            _context.next = 35;
            return actionRunner(state, {
              type: "set-menu-page",
              page: _activePage
            }, dispatch);

          case 35:
            return _context.abrupt("return", _context.sent);

          case 36:
            _context.next = 38;
            return dispatch({
              type: "toggle-experiments-panel",
              open: true
            });

          case 38:
            _context.next = 40;
            return actionRunner(state, {
              type: "set-menu-page",
              page: MenuPage.SETTINGS
            }, dispatch);

          case 40:
            return _context.abrupt("return", _context.sent);

          case 41:
            _pathname2 = state.router.location.pathname;

            if (isDetailPanelRoute(_pathname2)) {
              _context.next = 46;
              break;
            }

            newPathname = routerBasename + ((_action$page = action.page) !== null && _action$page !== void 0 ? _action$page : "");
            _context.next = 46;
            return dispatch(push({
              pathname: newPathname,
              hash: location.hash
            }));

          case 46:
            return _context.abrupt("return", {
              type: "set-menu-page",
              page: action.page
            });

          case 47:
            pathname = routerBasename + ((_state$menu$activePag = state.menu.activePage) !== null && _state$menu$activePag !== void 0 ? _state$menu$activePag : "");
            _context.next = 50;
            return dispatch(push({
              pathname: pathname,
              hash: location.hash
            }));

          case 50:
            return _context.abrupt("return", action);

          case 51:
            term = action.term;
            CancelToken = axios.CancelToken;
            source = CancelToken.source();
            dispatch({
              type: "start-search-query",
              term: term,
              cancelToken: source
            });
            _context.next = 57;
            return axios.get(base + "/mobile/autocomplete", {
              params: {
                include: "interval,lithology,environ,strat_name",
                query: term
              },
              cancelToken: source.token,
              responseType: "json"
            });

          case 57:
            res = _context.sent;
            return _context.abrupt("return", {
              type: "received-search-query",
              data: res.data.success.data
            });

          case 59:
            mapInfo = coreState.mapInfo;
            CancelToken1 = axios.CancelToken;
            source1 = CancelToken1.source();
            dispatch({
              type: "start-xdd-query",
              cancelToken: source1
            });
            _context.next = 65;
            return handleXDDQuery(mapInfo, source1.token);

          case 65:
            gdd_data = _context.sent;
            return _context.abrupt("return", {
              type: "received-xdd-query",
              data: gdd_data
            });

          case 67:
            result = action.result;

            if (!(result.type == "place")) {
              _context.next = 72;
              break;
            }

            return _context.abrupt("return", {
              type: "go-to-place",
              place: result
            });

          case 72:
            _context.next = 74;
            return runFilter(result);

          case 74:
            _context.t1 = _context.sent;
            return _context.abrupt("return", {
              type: "add-filter",
              filter: _context.t1
            });

          case 76:
            _context.next = 78;
            return runFilter(action.filter);

          case 78:
            _context.t2 = _context.sent;
            return _context.abrupt("return", {
              type: "add-filter",
              filter: _context.t2
            });

          case 80:
            _context.next = 82;
            return fetchFilteredColumns(coreState.filters);

          case 82:
            _context.t3 = _context.sent;
            return _context.abrupt("return", {
              type: "update-column-filters",
              columns: _context.t3
            });

          case 84:
            _lng = action.lng, _lat = action.lat, _z = action.z;
            ln = formatCoordForZoomLevel(_lng, Number(_z));
            lt = formatCoordForZoomLevel(_lat, Number(_z));
            return _context.abrupt("return", push({
              pathname: routerBasename + "loc/".concat(ln, "/").concat(lt),
              hash: location.hash
            }));

          case 88:
            lng = action.lng, lat = action.lat, z = action.z, map_id = action.map_id; // Get column data from the map action if it is provided.
            // This saves us from having to filter the columns more inefficiently

            column = action.column;
            CancelTokenMapQuery = axios.CancelToken;
            sourceMapQuery = CancelTokenMapQuery.source();

            if (!(coreState.inputFocus && coreState.contextPanelOpen)) {
              _context.next = 94;
              break;
            }

            return _context.abrupt("return", {
              type: "context-outside-click"
            });

          case 94:
            dispatch({
              type: "start-map-query",
              lng: lng,
              lat: lat,
              cancelToken: sourceMapQuery
            });
            _context.next = 97;
            return runMapQuery(lng, lat, z, map_id, sourceMapQuery.token);

          case 97:
            mapData = _context.sent;

            if (column == null && state.core.allColumns != null && state.core.mapLayers.has(MapLayer.COLUMNS)) {
              column = (_findColumnForLocatio = findColumnForLocation(state.core.allColumns, {
                lng: lng,
                lat: lat
              })) === null || _findColumnForLocatio === void 0 ? void 0 : _findColumnForLocatio.properties;
            }

            columnInfo = state.core.columnInfo;

            if (column != null && (columnInfo === null || columnInfo === void 0 ? void 0 : columnInfo.col_id) != column.col_id) {
              // Get the column units if we don't have them already
              actionRunner(state, {
                type: "get-column-units",
                column: column
              }, dispatch).then(dispatch);
            }

            coreState.infoMarkerPosition = {
              lng: lng,
              lat: lat
            };
            return _context.abrupt("return", {
              type: "received-map-query",
              data: mapData
            });

          case 103:
            CancelTokenGetColumn = axios.CancelToken;
            sourceGetColumn = CancelTokenGetColumn.source();
            dispatch({
              type: "start-column-query",
              cancelToken: sourceMapQuery
            });
            _context.next = 108;
            return runColumnQuery(action.column, sourceGetColumn.token);

          case 108:
            columnData = _context.sent;
            return _context.abrupt("return", {
              type: "received-column-query",
              data: columnData,
              column: action.column
            });

          case 110:
            CancelTokenElevation = axios.CancelToken;
            sourceElevation = CancelTokenElevation.source();
            dispatch({
              type: "start-elevation-query",
              cancelToken: sourceElevation.token
            });
            _context.next = 115;
            return asyncGetElevation(action.line, sourceElevation);

          case 115:
            elevationData = _context.sent;
            return _context.abrupt("return", {
              type: "received-elevation-query",
              data: elevationData
            });

          case 117:
            collection_nos = action.collection_nos;
            dispatch({
              type: "start-pdbd-query"
            });
            _context.next = 121;
            return getPBDBData(collection_nos);

          case 121:
            _context.t4 = _context.sent;
            return _context.abrupt("return", {
              type: "received-pbdb-query",
              data: _context.t4
            });

          case 123:
            return _context.abrupt("return", action);

          case 124:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _actionRunner.apply(this, arguments);
}

export default actionRunner;